import TableBody from "./TableBody";
import TableThead from "./TableThead";
import Table from "react-bootstrap/Table";
import { useEffect, useState } from "react";
import { calculateWeekNumbers } from "../../utils/helper";

const TableView = ({
	loading,
	wpUserLoggedIn,
	activeTab,
	year,
	categories,
	comments,
	setComments,
	setUpdatedValue,
}) => {
	// State for storing week numbers
	const [weekNumbers, setWeekNumbers] = useState([]);
	const commentSection = comments.length >= 1 && comments.length <= 6;

	// Effect hook to update week numbers when activeTab or year changes
	useEffect(() => {
		// Calculate new week numbers based on activeTab and year
		const newWeekNumbers = calculateWeekNumbers(activeTab, year);
		// Update week numbers state with the new week numbers
		setWeekNumbers(newWeekNumbers);
	}, [activeTab, year]);

	// Render the TableView component
	return (
		<>
			{/* Bootstrap responsive table */}
			{/* <pre>{JSON.stringify(comments.length, null, 2)}</pre> */}
			<span className={`${commentSection ? 'comment-section-hight' : ''}`}>
				<Table responsive className={"table table-bordered text-center"}>
					{/* Render TableThead component with weekNumbers as props */}
					<TableThead
						wpUserLoggedIn={wpUserLoggedIn}
						weekNumbers={weekNumbers}
					/>

					{/* Render TableBody component with necessary props */}
					<TableBody
						loading={loading}
						wpUserLoggedIn={wpUserLoggedIn}
						year={year}
						categories={categories}
						weekNumbers={weekNumbers}
						comments={comments}
						setComments={setComments}
						setUpdatedValue={setUpdatedValue}
					/>
				</Table>
			</span>
		</>
	);
};

export default TableView;
